import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { ReleasePost } from '../../../../../redux/api/fymAPI.types';
import { planPostState } from './planModel';
import { POST_STATE_CLASS, POST_STATE_MESSAGES, postPlatformName, releasePostName } from './planPostLabels';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Plan tab; each part uses its own slice of it */
import styles from './Plan.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PlanPostChipProps {
  post: ReleasePost;
}

/**
 * One post on a timeline day (design f1): what it uses, then "Posted · Instagram",
 * "18:00 · TikTok" or "Draft · Instagram", in the colour of its state.
 */
const PlanPostChipComponent: React.FC<PlanPostChipProps> = ({ post }) => {
  const intl = useIntl();
  const state = planPostState(post.status);
  const channel = postPlatformName(post.platform);
  const detail =
    state === 'scheduled'
      ? `${intl.formatTime(new Date(post.scheduledAt), { hour: '2-digit', minute: '2-digit' })} · ${channel}`
      : `${intl.formatMessage(POST_STATE_MESSAGES[state])} · ${channel}`;

  return (
    <div className={clsx(styles.postChip, POST_STATE_CLASS[state])} data-testid="plan-post-chip">
      <b>{releasePostName(intl, post)}</b>
      <small>{detail}</small>
    </div>
  );
};

export const PlanPostChip = TypedMemo(PlanPostChipComponent);
